import { observer } from "mobx-react";
import { store } from "../../store";
import { cn } from "@/lib/utils";
import { bookDemoUrl } from "../../utils/constants";

export interface NotACustomerYetProps {
    className?: string;
}

export const NotACustomerYet = observer(({ className }: NotACustomerYetProps): JSX.Element => {
    const t = store.i18n.t;

    return (
        <p className={cn("text-muted-foreground text-center text-sm", className)}>
            {t("notACustomerYet.text")}{" "}
            <a
                href={bookDemoUrl}
                target="_blank"
                rel="noreferrer"
                className="text-foreground font-bold hover:underline"
            >
                {t("notACustomerYet.trial")}
            </a>
        </p>
    );
});
